// Application version - update this with each release
export const APP_VERSION = '1.12.2';

// Semantic version comparison utility
export const compareVersions = (version1: string, version2: string): number => {
  const v1parts = version1.split('.').map(Number);
  const v2parts = version2.split('.').map(Number);
  
  const maxLength = Math.max(v1parts.length, v2parts.length);
  
  for (let i = 0; i < maxLength; i++) {
    const v1part = v1parts[i] || 0;
    const v2part = v2parts[i] || 0;
    
    if (v1part < v2part) return -1;
    if (v1part > v2part) return 1;
  }
  
  return 0;
};

// Check if version1 is newer than version2
export const isNewerVersion = (version1: string, version2: string): boolean => {
  return compareVersions(version1, version2) > 0;
};

// Version management utilities
// The "current" version is always the code actually running (APP_VERSION).
export const getStoredVersion = (): string => APP_VERSION;

const DISMISSED_KEY = 'app_version_dismissed';
const RELOAD_KEY = 'app_version_reload_attempted';

export const getDismissedVersion = (): string | null => localStorage.getItem(DISMISSED_KEY);
export const setDismissedVersion = (version: string): void => {
  localStorage.setItem(DISMISSED_KEY, version);
};
export const getReloadAttempted = (): string | null => sessionStorage.getItem(RELOAD_KEY);
export const setReloadAttempted = (version: string): void => {
  sessionStorage.setItem(RELOAD_KEY, version);
};

// Kept for backwards compatibility; marks a version as handled.
export const setStoredVersion = (version: string): void => setDismissedVersion(version);

export const initializeVersion = (): void => {
  localStorage.removeItem('app_version');
};

// Show only if the DB version is newer than the running code and not dismissed
export const shouldShowUpdateNotification = (
  _currentVersion: string,
  latestDbVersion: string
): boolean => {
  if (!isNewerVersion(latestDbVersion, APP_VERSION)) return false;
  if (getDismissedVersion() === latestDbVersion) return false;
  // Already reloaded once this session and still on old code: stop looping
  if (getReloadAttempted() === latestDbVersion) {
    setDismissedVersion(latestDbVersion);
    return false;
  }
  return true;
};